import { render, staticRenderFns } from "./ChatChatHistory.vue?vue&type=template&id=1f20bc3c&"
import script from "./ChatChatHistory.vue?vue&type=script&lang=js&"
export * from "./ChatChatHistory.vue?vue&type=script&lang=js&"
import style0 from "./ChatChatHistory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports